<template>
    <div :style="{ backgroundColor: this.$route.params.color }"
          style="min-height: calc(100vh);">

        <div class="transparentBackground text-center text-md-right pt-2 pr-2">
            <router-link class="btn btn-outline-secondary" :to="{ name: 'ResultsScreen', params: { testId: testId }}">
                <i class="fas fa-times-circle"/> Close
            </router-link>
        </div>
        <div class="pt-1" style="min-height: 20rem">
            <test-pattern-text :selected-test-pattern-id="selectedTestPatternId"></test-pattern-text>
        </div>
        <div class="selectorButtons row justify-content-md-center mx-3 mt-5">
            <div class="col-md-9">
                <selection-component :items="testPatternOptions" :is-transparent="true"
                                     v-on:selected="updateSelectedTestPatternId"></selection-component>
            </div>
        </div>
    </div>
</template>

<script>
    import TestPatternText from '@/components/TestPatternText';
    import SelectionComponent from '@/components/selectionComponent/SelectionComponent';

    export default {
        name: 'PreferredFilterPreview',
        components: {SelectionComponent, TestPatternText},
        data() {
            return {
                selectedTestPatternId: 'Text',
                testPatternOptions: [
                    {id: 'Color', label: 'Colors Only', icon: 'square'},
                    {id: 'Text', label: 'Text', icon: 'font', isSelected: true},
                    {id: 'Nonsense', label: 'Nonsense', icon: 'align-justify'},
                ],
            };
        },
        computed: {
            testId() {
                return this.$route.params.testId;
            },
        },
        methods: {
            updateSelectedTestPatternId(selectionId) {
                this.selectedTestPatternId = selectionId;
            },
        },
    };
</script>

<style scoped>
    .selectorButtons {
        /*position: absolute;*/
        /*top: calc(100vh - 13rem);*/
    }

    .transparentBackground {
        background: rgba(76, 175, 80, 0.0);
    }

    .fullCalculatedHeight {
        height: calc(100vh);
    }

</style>
